module.exports = __webpack_public_path__ + "static/media/2.7dd8c4bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/baranovichi/2.jpg
// module id = 206
// module chunks = 0